package br.com.vvrefeicoes.portal.domain.model

data class SatisfactionMonth(
    val period: MonthPeriod,
    val votes: Int,
    val participationPercent: Double,
    val satisfactionPercent: Double,
)

data class RatingCounts(
    val excellent: Int,
    val good: Int,
    val regular: Int,
    val bad: Int,
) {
    val total: Int
        get() = excellent + good + regular + bad

    val positive: Int
        get() = excellent + good
}

data class MonthPerformance(
    val period: MonthPeriod,
    val counts: RatingCounts,
)

data class UnitSatisfaction(
    val location: String,
    val votes: Int,
    val counts: RatingCounts,
    val participationPercent: Double,
    val satisfactionPercent: Double,
    val achieved: Boolean,
)

data class SatisfactionSnapshot(
    val periodLabel: String,
    val months: List<MonthPeriod>,
    val totalVotes: Int,
    val goalPercent: Double,
    val participationPercent: Double,
    val satisfactionPercent: Double,
    val achieved: Boolean,
    val counts: RatingCounts,
    val evolution: List<SatisfactionMonth>,
    val performance: List<MonthPerformance>,
    val units: List<UnitSatisfaction>,
) {
    companion object {
        val Empty =
            SatisfactionSnapshot(
                periodLabel = "",
                months = emptyList(),
                totalVotes = 0,
                goalPercent = 0.0,
                participationPercent = 0.0,
                satisfactionPercent = 0.0,
                achieved = false,
                counts = RatingCounts(0, 0, 0, 0),
                evolution = emptyList(),
                performance = emptyList(),
                units = emptyList(),
            )
    }
}
